import Typewriter from 'typewriter-effect';
import {Trans } from 'react-i18next';

const Hero = () => {
  
    return (
        <header className="h-screen pt-16 sm:pt-14">
          
          <div id="herodivimage"> </div>
          <div className='font-bold text-6xl text-orange-600 bg-white bg-opacity-80 mt-32 sm:pt-32 lg:w-2/4'>
            <Typewriter
              options={{
                strings: ["Hello", "Bonjour", "Hola", "おはよう", "Bom dia",],
                autoStart: true,
                loop: true,
              }}
            />
            <h1 className='text-sky-900 text-center my-8 text-4xl'>
              <Trans i18nKey='h1'>
                Grow your business everywhere by showing your content to new customers in their language
              </Trans>
              </h1>
              <div className='text-center pl-10 sm:pl-32 md:pl-32 2xl:pl-32'>
                <p className='text-purple-700 text-center text-2xl lg:text-2xl xl:text-4xl  my-8 flex w-full'>    
                <Typewriter
                  options={{
                    strings: ["Get more sales!", " ¡Incrementa las ventas!", "売上アップ！",],
                    autoStart: true,
                    loop: true,
                  }}
                  />
                  </p>

              </div>
          </div>
        </header>
    )
}

export default Hero